
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "19px",
    "height": "15px"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "fill": "rgb(148, 155, 174)",
        "d": "M17.173,8.500 L14.173,8.500 C13.621,8.500 13.173,8.052 13.173,7.500 C13.173,6.948 13.621,6.500 14.173,6.500 L17.173,6.500 C17.725,6.500 18.173,6.948 18.173,7.500 C18.173,8.052 17.725,8.500 17.173,8.500 ZM17.173,4.500 L14.173,4.500 C13.621,4.500 13.173,4.052 13.173,3.500 C13.173,2.948 13.621,2.500 14.173,2.500 L17.173,2.500 C17.725,2.500 18.173,2.948 18.173,3.500 C18.173,4.052 17.725,4.500 17.173,4.500 ZM11.626,14.502 C11.305,14.502 6.120,14.502 6.120,14.502 C6.120,14.502 2.491,14.495 0.704,14.495 C0.352,14.495 0.170,14.156 0.174,13.851 C0.189,12.823 0.935,11.754 1.119,11.600 C1.119,11.600 1.656,11.013 2.728,10.434 C3.486,10.024 4.228,9.791 4.438,9.360 C4.588,9.053 4.552,8.986 4.471,8.515 C4.421,8.228 4.275,7.308 4.089,6.992 C3.985,6.815 3.377,6.869 3.207,5.745 C3.063,4.798 3.579,4.712 3.486,4.397 C3.235,3.553 3.136,2.710 3.187,2.408 C3.372,1.322 4.185,0.536 6.172,0.500 C7.942,0.467 8.937,1.331 9.116,2.432 C9.164,2.724 9.057,3.474 8.942,4.428 C8.891,4.849 9.264,5.217 9.117,5.856 C8.889,6.848 8.514,6.638 8.219,7.062 C7.952,7.445 7.794,8.413 7.792,8.477 C7.784,8.759 7.743,9.124 7.822,9.363 C7.950,9.753 8.855,10.005 9.664,10.480 C10.764,11.126 11.189,11.583 11.189,11.583 C11.606,11.987 12.172,12.853 12.172,13.851 C12.172,14.339 11.944,14.502 11.626,14.502 ZM14.173,10.500 L17.173,10.500 C17.725,10.500 18.173,10.948 18.173,11.500 C18.173,12.052 17.725,12.500 17.173,12.500 L14.173,12.500 C13.621,12.500 13.173,12.052 13.173,11.500 C13.173,10.948 13.621,10.500 14.173,10.500 Z"
      }
    }
  ]
})
    }
  